export default __webpack_public_path__ + "static/media/logistic.769ee2ed.png";